import React from 'react';
import sentenceInCapitalized from '../../../helpers/utils/sentenceInCapitalized';

interface BadgeProps {
  statusClass?: string;
  children: React.ReactNode;
  capitalize?: boolean;
}

const Badge = ({ statusClass = '', children, capitalize = false }: BadgeProps) => {
  return (
    <div
      className={`p-2 w-full h-full border border-gray-200 rounded-full text-black capitalize text-md flex justify-center items-center font-Montserrat ${statusClass} status-badge`}
    >
      {capitalize ? sentenceInCapitalized(children) : children}
    </div>
  );
};

export default Badge;
